import { ReactElement } from "react";
import {
  ArrowRightLeftIcon,
  ClipboardCheckIcon,
  ClipboardListIcon,
  FileTextIcon,
  MailIcon,
  MessageCircleIcon,
  MessageSquareTextIcon,
  PencilLineIcon,
  PhoneIcon,
  SparklesIcon,
  StickyNoteIcon,
  type LucideIcon,
} from "lucide-react";

import { Row } from "@/components";
import { cn } from "@/lib/utils";

export type CitationSourceIcon = ({
  className,
}: {
  className?: string;
}) => ReactElement;

export const CitationSourceIconDisplay = ({
  className,
  Icon,
}: {
  className?: string;
  Icon: CitationSourceIcon;
}) => {
  return <Icon className={cn("h-4 w-4 shrink-0 text-slate-400", className)} />;
};

const createCitationSourceIcon = (Icon: LucideIcon): CitationSourceIcon => {
  const CitationIcon = ({ className }: { className?: string }) => {
    return <Icon className={className} strokeWidth={1.5} />;
  };

  return CitationIcon;
};

const createAgenticCitationSourceIcon = (
  Icon: LucideIcon,
): CitationSourceIcon => {
  const AgenticCitationIcon = ({ className }: { className?: string }) => {
    return (
      <Row className={cn("relative", className)}>
        <Icon className="h-full w-full" strokeWidth={1.5} />
        <SparklesIcon
          className="absolute -right-1 -top-1 !size-2.5"
          strokeWidth={1.75}
        />
      </Row>
    );
  };

  return AgenticCitationIcon;
};

export const EmailCitationIcon = createCitationSourceIcon(MailIcon);
export const CallCitationIcon = createCitationSourceIcon(PhoneIcon);
export const TextCitationIcon = createCitationSourceIcon(MessageSquareTextIcon);
export const ResumeCitationIcon = createCitationSourceIcon(FileTextIcon);
export const ApplicationQuestionsCitationIcon =
  createCitationSourceIcon(ClipboardListIcon);
export const CommentsCitationIcon = createCitationSourceIcon(MessageCircleIcon);
export const NoteCitationIcon = createCitationSourceIcon(StickyNoteIcon);
export const StatusChangeCitationIcon =
  createCitationSourceIcon(ArrowRightLeftIcon);
export const EditCitationIcon = createCitationSourceIcon(PencilLineIcon);
export const AgenticEmailCitationIcon =
  createAgenticCitationSourceIcon(MailIcon);
export const AgenticCallCitationIcon =
  createAgenticCitationSourceIcon(PhoneIcon);
export const AgenticTextCitationIcon = createAgenticCitationSourceIcon(
  MessageSquareTextIcon,
);

// Technically not in use right now.
export const EvaluationCitationIcon =
  createCitationSourceIcon(ClipboardCheckIcon);
